import axios from 'axios';
import resolve  from './../resolver.js';

export default async function Login(username, password, domain, role = "client") {
    return await resolve(
        axios(role + '/login', {
            method: 'post',
            header: { 'Content-Type' : 'application/json'},
            data: { 
                "username": username,
                "password": password,
                ...(role === "client" ? {"domain": domain} : {})
            }
        })
        .then(res => res.data))
        .catch(error => {
            console.log(error.response.data.message);
          });
}